import Checkbox from '@liveauctioneers/caterwaul-components/lib/Checkbox/Checkbox';
import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';
import { BodySecondary, Caption, H5, H6 } from '@liveauctioneers/hammer-ui-core/text';
import * as React from 'react';
import styled, { useTheme } from 'styled-components';

import useWindowSize from '@/hooks/useWindowSize';
import { useAppDispatch } from '@/redux/hooks';
import { toggleEmailListSubscription } from '@/redux/modules/account/notifications/emailList/emailList.actions';
import { UNSUBSCRIBE_TO_ALL_EMAIL_LISTS } from '@/redux/modules/account/notifications/emailList/emailList.types';

import TableRow from './TableRow';

type Props = {
    code: string;
    description: string;
    frequency: string;
    name: string;
    subscribed: boolean;
};

const NotificationRow = ({ code, description, frequency, name, subscribed }: Props) => {
    const { formatMessage } = useIntl();
    const dispatch = useAppDispatch();
    const frequencyText = frequency === 'Real Time' ? 'Real-Time' : frequency;
    const toggleEmail = React.useCallback(() => {
        dispatch(toggleEmailListSubscription({ code }));
    }, [code, dispatch]);

    const { width } = useWindowSize();
    const {
        breakpoints: { tabletNarrowWidthNum },
    } = useTheme();

    if (code === UNSUBSCRIBE_TO_ALL_EMAIL_LISTS) {
        return null;
    }

    return (
        <StyledTableRow
            email={
                <StyledCheckbox
                    checked={subscribed}
                    label={formatMessage({ id: 'notificationsPage.toggleEmailNotifcations' }, { name })}
                    labelDisplay=""
                    name="emailCheckbox"
                    onClick={toggleEmail}
                />
            }
            frequency={width > tabletNarrowWidthNum && <BodySecondary>{frequencyText}</BodySecondary>}
            type={
                <>
                    {width > tabletNarrowWidthNum ? <H5>{name}</H5> : <H6>{name}</H6>}
                    {width <= tabletNarrowWidthNum ? (
                        <Caption>{description}</Caption>
                    ) : (
                        <BodySecondary color="secondary">{description}</BodySecondary>
                    )}
                </>
            }
        />
    );
};

const StyledTableRow = styled(TableRow)`
    @media (max-width: ${({ theme }) => theme.breakpoints.tabletNarrowWidth}) {
        > :nth-child(1) {
            grid-column: 1 / 5;
        }
    }
`;

export default React.memo<Props>(NotificationRow);

const StyledCheckbox = styled(Checkbox)`
    margin-bottom: 0;
`;
